import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Button, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import { MdModeEditOutline,MdSave, MdClose, MdDone } from 'react-icons/md';
import { Line, Pie, Bar, Doughnut, Radar, PolarArea, Bubble, Scatter } from 'react-chartjs-2';
import './chat.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Sidebar from './Layout/Sidebar';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Chart, registerables } from 'chart.js';
import Cookies from 'js-cookie';
import { dotWave } from 'ldrs'
import { dotPulse } from 'ldrs'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {encryptData, decryptData } from "../../Auth/cryptage";
import logoGc from "../../imgs/logoGc.png";
import { IoRefreshOutline } from "react-icons/io5";
import { components } from 'react-select';


function Chat({ setSidebarOpen, sidebarOpen,handleChatButtonClick }) {
    const [formValues, setFormValues] = useState({ message: '' });
    const [messages, setMessages] = useState(() => {
        const encryptedData = sessionStorage.getItem('messages');
        if (encryptedData) {
            const decryptedData = decryptData(encryptedData);
            return decryptedData && decryptedData.messages ? decryptedData.messages : [];
        } else {
            console.warn('No data found in sessionStorage.');
            return [];
        }
    });
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [savedQuestions, setSavedQuestions] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [title, setTitle] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [editMessage, setEditMessage] = useState(null);
    const [editMessageContent, setEditMessageContent] = useState('');
    const [updateQuestions, setUpdateQuestions] = useState(() => () => {});
    const messagesEndRef = useRef(null);
    const MySwal = withReactContent(Swal);
    dotPulse.register()
    dotWave.register()
    Chart.register(...registerables);

    useEffect(() => {
        AOS.init({ duration: 1200 });
        handleChatButtonClick();
    }, []);
    useEffect(() => {
        const storageData=decryptData(sessionStorage.getItem('messages'));
        const retrievedObject = JSON.parse(storageData);
        if (retrievedObject) {
            setMessages(retrievedObject.messages || []);
            setCount(retrievedObject.messages ? retrievedObject.messages.length : 0);
        }
        scrollToBottom();
    }, []);
    useEffect(() => {
        document.title = "GecimmoIA - Chat";
    }, []); 
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };
    const handleChange = (e) => {
        setFormValues({ ...formValues, message: e.target.value });
    };
    const addLoadingMessage = () => {
        const newMessages = [
            ...messages,
            { role: 'user', content: formValues.message },
            { role: 'assistant', content: 'Loading...', graph: 'non' }
        ];
        setMessages(newMessages);
        sessionStorage.setItem('messages', encryptData(JSON.stringify({ messages: newMessages })));
        setCount(count + 2);
        setFormValues({ message: '' });
    };

    const updateLoadingMessage = (responseMessages) => {
        const updatedMessages = responseMessages.map((message, index) => {
            if (message.role === 'assistant' && message.content === 'Loading...') {
                return responseMessages[responseMessages.length - 1];
            }
            return message;
        });
        setMessages(updatedMessages);
        sessionStorage.setItem('messages', encryptData(JSON.stringify({ messages: updatedMessages })));
    };

    const newChat = () => {
        const newMessages = messages.slice(0, 3);
        setMessages(newMessages);   
        setCount(3);
        sessionStorage.setItem('messages', encryptData(JSON.stringify({ messages: newMessages })));
        // sessionStorage.setItem('messages', JSON.stringify({ messages: newMessages }));
    };

    const handleSubmitGraph = async (e) => {
        e.preventDefault();
        setLoading(true);
        addLoadingMessage();
        const token = decryptData(Cookies.get('access_token'));

        try {
            const response = await axios.post('https://api.ai.easysystem.cloud/api/user/chat', {
                message: formValues.message,
                messages: messages,
                condition: "oui"
            }, {
                headers: { "X-Custom-Token": token }
            });

            setMessages(response.data.messages);
            setCount(response.data.messages.length);
            updateLoadingMessage(response.data.messages);
            // console.log()(response.data.messages);

        } catch (error) {
            if (error.response) {
                console.error('Server responded with an error:', error.response.data);
                Swal.fire({
                    icon: 'error',
                    title: 'Server Error',
                    text: error.response.data.message || 'Something went wrong!',
                    footer: '<a href="#">Why do I have this issue?</a>'
                });
            } else if (error.request) {
                console.error('No response received:', error.request);
                Swal.fire({
                    icon: 'error',
                    title: 'Network Error',
                    text: 'No response received from the server.',
                    footer: '<a href="#">Why do I have this issue?</a>'
                });
            } else {
                console.error('Error in request setup:', error.message);
                Swal.fire({
                    icon: 'error',
                    title: 'Request Error',
                    text: error.message,
                    footer: '<a href="#">Why do I have this issue?</a>'
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleErrsEffect = (originalMessages) => {
        setMessages(originalMessages);
        setCount(originalMessages.length);
        sessionStorage.setItem('messages', encryptData(JSON.stringify({ messages: originalMessages })));
    }

    const handleSubmitText = async (e) => {
        e.preventDefault();
        setLoading(true);
        const originalMessages = [...messages];
        addLoadingMessage();
        const token = decryptData(Cookies.get('access_token'));
        try {
            const response = await axios.post('https://api.ai.easysystem.cloud/api/user/chat', {
                message: formValues.message,
                messages: messages,
                condition: "non"
            }, {
                headers: { "X-Custom-Token": token }
            });
    
            setMessages(response.data.messages);
            setCount(response.data.messages.length);
            updateLoadingMessage(response.data.messages);
    
        } catch (error) {
            if (error.response) {
                console.error('Server responded with an error:', error.response.data);
                Swal.fire({
                    icon: 'error',
                    title: 'Server Error',
                    text: error.response.data.message || 'Something went wrong!',
                });
            } else if (error.request) {
                console.error('No response received:', error.request);
                Swal.fire({
                    icon: 'error',
                    title: 'Network Error',
                    text: 'No response received from the server.',
                });
            } else {
                console.error('Error in request setup:', error.message);
                Swal.fire({
                    icon: 'error',
                    title: 'Request Error',
                    text: error.message,
                });
            }
            handleErrsEffect(originalMessages);
        }finally{
            setLoading(false);
        }
    };
        
    const graphComponents = {
        bar: Bar,
        line: Line,
        pie: Pie,
        doughnut: Doughnut,
        radar: Radar,
        polarArea: PolarArea,
        bubble: Bubble,
        scatter: Scatter,
    };
    
    const getStyle = (type) => {
        const typesWithStyles = ['pie', 'doughnut', 'radar'];
        const isSmallScreen = window.innerWidth < 600;
        const baseStyle = typesWithStyles.includes(type)
            ? { display: 'flex', width: '60%', height: '60%' }
            : {};
        if (isSmallScreen && typesWithStyles.includes(type)) {
            return { ...baseStyle, width: '90%', height: '90%' };
        }
    
        return baseStyle;
    };
    
    const renderError = (index, message) => (
        <span key={`${index}-error`} className='text-dark'>{message}</span>
    );
    
    const renderGraphComponent = (Component, data, options, index, style) => (
        <span className={`pdfMainContainer${index}`} style={style}>
            <Component className='graphsItems' key={`${index}`} data={data} options={options} />
        </span>
    );
    
    const renderGraph = (graphData, index) => {
        let jsonData;
        try {
            jsonData = JSON.parse(graphData);
        } catch (error) {
            console.error('Error parsing JSON:', error);
            Swal.fire({
                icon: 'error',
                title: 'JSON Parsing Error',
                text: 'Unable to parse the graph data. Please check the data format.',
            });
            return renderError(index, 'Try again please');
        }
    
        const renderSingleGraph = (element, i) => {
            if (!element.type || !element.data) {
                console.error('Invalid graph element structure:', element);
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Graph Structure',
                    text: 'Graph element structure is invalid. Missing type or data.',
                });
                return renderError(`${index}-${i}`, 'Invalid structure');
            }
    
            const GraphComponent = graphComponents[element.type];
            if (!GraphComponent) {
                console.warn('Unknown graph type:', element.type);
                return renderError(`${index}-${i}`, 'Unknown graph type');
            }
    
            const style = getStyle(element.type);
            try {
                return renderGraphComponent(GraphComponent, element.data, element.options, index, style);
            } catch (error) {
                console.error('Error rendering graph element:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Rendering Error',
                    text: 'An error occurred while rendering the graph.',
                });
                return renderError(`${index}-${i}`, 'Rendering error');
            }
        };
    
        if (Array.isArray(jsonData)) {
            return jsonData.map((element, i) => renderSingleGraph(element, i));
        } else {
            return renderSingleGraph(jsonData, index);
        }
    };

    const downloadGraphAsPdf = async (index) => {
        try {
            const { value: formValues } = await Swal.fire({
                title: 'Entrez les détails pour votre PDF',
                html: `
                    <input type="text" id="pdfFileName" class="swal2-input" placeholder="Nom du fichier PDF">
                    <input type="text" id="messageTitle" class="swal2-input" placeholder="Titre du message">
                `,
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonText: 'Télécharger',
                confirmButtonColor: 'blue',
                cancelButtonText: 'Annuler',
                cancelButtonColor: 'red',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    const pdfFileName = document.getElementById('pdfFileName').value;
                    const messageTitle = document.getElementById('messageTitle').value;
    
                    if (!pdfFileName || !messageTitle) {
                        Swal.showValidationMessage('Les champs ne peuvent pas être vides');
                        return false;
                    }
    
                    return { pdfFileName, messageTitle };
                },
                allowOutsideClick: () => !Swal.isLoading(),
            });
    
            if (!formValues) return;
    
            const { pdfFileName, messageTitle } = formValues;
    
            const graphElements = document.querySelectorAll(`.pdfMainContainer${index}`);
            if (graphElements.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Aucun graphique trouvé',
                    text: "Aucun graphique n'a été trouvé pour générer le PDF.",
                });
                return;
            }
    
            const pdf = new jsPDF();
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const currentDate = new Date().toLocaleString();
    
            const loadImage = (src) => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.src = src;
                    img.onload = () => resolve(img);
                    img.onerror = (error) => reject(error);
                });
            };
    
            const logoImg = await loadImage(logoGc);
            const logoWidth = 50;
            const logoHeight = (logoImg.height * logoWidth) / logoImg.width;
            const logoX = 10; 
            const logoY = 5;
    
            const addHeader = (pdf, title) => {
                pdf.addImage(logoImg, 'PNG', logoX, logoY, logoWidth, logoHeight);
                pdf.setFont('helvetica', 'bold');
                pdf.setTextColor(30, 30, 30);
                pdf.text(title, pdfWidth / 2, 40, { align: 'center' });
                pdf.setFontSize(12);
                pdf.text(`Date: ${currentDate}`, pdfWidth - logoWidth - 20, 15);
            };
    
            const addHeaderEachPage = (pdf) => {
                pdf.addImage(logoImg, 'PNG', logoX, logoY, logoWidth, logoHeight);
                pdf.setFont('helvetica', 'bold');
                pdf.setTextColor(30, 30, 30);
                pdf.text(`Date: ${currentDate}`, pdfWidth - logoWidth - 20, 15); 
            };
    
            addHeader(pdf, messageTitle);
    
            for (let i = 0; i < graphElements.length; i++) {
                const element = graphElements[i];
                const graphType = element.getAttribute('data-graph-type');
                let scaleFactor = 1.0;
                if (['pie', 'doughnut', 'radar'].includes(graphType)) {
                    scaleFactor = 0.8;
                }
    
                const canvas = await html2canvas(element, { scrollY: -window.scrollY });
                const imgData = canvas.toDataURL('image/png');
                const imgProps = pdf.getImageProperties(imgData);
                const imgWidth = (pdfWidth - (pdfWidth / 8)) * scaleFactor;
                const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
                const xPosition = (pdfWidth - imgWidth) / 2;
                const yPosition = (pdfHeight - imgHeight) / 2 + 50;
    
                if (i > 0) {
                    pdf.addPage();
                    addHeaderEachPage(pdf);
                }
    
                pdf.addImage(imgData, 'PNG', xPosition, yPosition, imgWidth, imgHeight);
                pdf.setFontSize(10);
                pdf.setTextColor(100);
                pdf.text(`Page ${i + 1} of ${graphElements.length}`, pdfWidth - 20, pdfHeight - 10, {
                    align: 'right',
                });
            }
    
            pdf.save(`${pdfFileName}.pdf`);
        } catch (error) {
            console.error('Error generating PDF:', error);
            Swal.fire({
                icon: 'error',
                title: 'Download Error',
                text: 'An error occurred while generating the PDF. Please try again.',
            });
        }
    };
    
    const handleSave = (question) => {
        // console.log()(question);
        setSavedQuestions(question);
        setShowModal(true);
    };

    const handleSaveQuestion = async () => {
        setLoading(true);

        if (!title || !savedQuestions) {
            setLoading(false);
            MySwal.fire({
                title: 'Validation Error',
                text: 'Title and content cannot be empty.',
                icon: 'warning'
            });
            return;
        }
        
        try {
            const token = decryptData(Cookies.get('access_token'));

            await axios.post('https://api.ai.easysystem.cloud/api/user/save-message', {
                title: title,
                content: savedQuestions,
                messages: messages,
                typeQ: 'text'
            }, {
                headers: { "X-Custom-Token": token }
            });

            setTitle('');
            setShowModal(false);
            MySwal.fire({ 
                title: 'Success!', 
                text: 'Question saved successfully.', 
                icon: 'success' 
            });

            updateQuestions();

        } catch (error) {
            console.error('There was an error making the request:', error);

            MySwal.fire({
                title: 'Error!',
                text: 'There was an error saving the question. Please try again.',
                icon: 'error'
            });

        } finally {
            setLoading(false);
        }
    };

    const handleEditChange = (e) => {
        setEditMessageContent(e.target.value);
    };


    const handleEdit = (message) => {
        setIsEditing(true);
        setEditMessage(message);
        setEditMessageContent(message.content);
    };

    const handleCancelEdit = () => {
        setIsEditing(false);
        setEditMessage(null);
        setEditMessageContent('');
    };

    const handleUpdateMessage = async (index) => {
        setLoading(true);
        // console.log()(editMessageContent, index);
        if (!editMessageContent || index == null) {
            setLoading(false);
            Swal.fire({
                title: 'Validation Error',
                text: 'Message content is missing.',
                icon: 'warning'
            });
            return;
        }
        // console.log()(messages[index+3]);
        const token = decryptData(Cookies.get('access_token'));
        try {
            const response = await axios.post(`https://api.ai.easysystem.cloud/api/user/update-message/${index}`, {
                messageContent: editMessageContent,
                messages: messages,
            },{
                headers: { 
                    "X-Custom-Token": token 
                }
            });
            
            const updatedMessages = response.data.messages;
            // console.log()(updatedMessages);
            sessionStorage.setItem('messages', encryptData(JSON.stringify({ messages: updatedMessages })));
            setMessages(updatedMessages);
    
            setIsEditing(false);
            setEditMessage(null);
            setEditMessageContent('');
    
            Swal.fire({
                title: 'Success!',
                text: 'Message updated successfully.',
                icon: 'success'
            });
    
        } catch (error) {
            console.error('There was an error making the request:', error);
            Swal.fire({
                title: 'Error!',
                text: 'An error occurred while updating the message. Please try again.',
                icon: 'error'
            });
    
        } finally {
            setLoading(false);
        }
    };
    
    
    const handleQuestionClick = (questionContent) => {
        setFormValues({ message: questionContent });
        setSidebarOpen(false)
        // handleSubmitText({ preventDefault: () => {} });
    };
    const setUpdateSidebarQuestions = (func) => {
        setUpdateQuestions(() => func);
    };
    return (
        <Container className="d-flex flex-column justify-content-between chat-container">
            <Sidebar
                isOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
                onQuestionClick={handleQuestionClick}
                setUpdateSidebarQuestions={setUpdateSidebarQuestions}
                newChat={newChat}
                handleSave={handleSave}
            />         
            

            <Row className="flex-grow-1">
                <Col>
                    {count === 3 ? (
                        <div data-aos="zoom-in" className="welcome-message d-flex justify-content-center align-items-center w-100 h-100">
                            <h1 className='text-center'>Bienvenue dans une nouvelle conversation</h1>
                        </div>
                    ) : (
                        messages.slice(3).map((message,index) => (
                            <div key={index}>
                                {message.role === 'user' ? (
                                    <Row data-aos="fade-up" className="questionRow justify-content-end mt-5">
                                        <Col className="d-flex justify-content-end align-items-center">
                                            <div>
                                                {isEditing && editMessage.id === message.id ? (
                                                    <>
                                                        <Button className='btn-confirm' onClick={() => handleUpdateMessage(index)}>
                                                            <MdDone />
                                                        </Button>
                                                        <Button className='btn-close text-danger' onClick={handleCancelEdit}>
                                                            <MdClose />
                                                        </Button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Button className='btn-save' onClick={()=>handleQuestionClick(message.content)}>
                                                            <IoRefreshOutline />
                                                        </Button>
                                                        <Button className='btn-save' onClick={() => handleSave(message.content)}>
                                                            <MdSave />
                                                        </Button>
                                                        {/* <Button className='btn-save' onClick={() => handleEdit(message)}>
                                                            <MdModeEditOutline />
                                                        </Button> */}
                                                    </>
                                                )}
                                            </div>
                                            {isEditing && editMessage.id === message.id ? (
                                                <Form.Control
                                                    type="text"
                                                    value={editMessageContent}
                                                    onChange={handleEditChange}
                                                    className="questionDiv text-light w-100"
                                                />
                                            ) : (
                                                <div className="questionDiv">
                                                    {message.content}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                ) : message.role === 'assistant' ? (
                                    message.graph === "oui" ? (
                                        <Row data-aos="fade-up">
                                            <Col xs={8} className='col-graphs'>
                                                <div  key={index} className="chat-message assistant-message text-center w-100">
                                                    <div className="chart-container w-100">
                                                        <span id={`PdfContainer${index}`}>
                                                            {renderGraph(message.json, index)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xs={4} className="col-btn-PDFsave align-content-end">
                                                <Button className="btnSavePDF" onClick={()=>downloadGraphAsPdf(index)}>
                                                    <svg
                                                        className="btnSavePDFSvgIcon"
                                                        viewBox="0 0 384 512"
                                                        height="1em"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                                                        ></path>
                                                    </svg>
                                                    <span className="btnSavePDFIcon2"></span>
                                                    <span className="btnSavePDFInfo">En PDF</span>
                                                </Button>
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row data-aos="fade-up" className="responseRow">
                                            <Col>
                                                <div className="responseDiv">
                                                    {  message.content === 'Loading...' ? (
                                                        <l-dot-wave
                                                            size="47"
                                                            speed="1"
                                                            color="white"
                                                        ></l-dot-wave>
                                                    ):(
                                                        message.content
                                                        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                                                        .split('\n')
                                                        .map((line, i) => (
                                                            <React.Fragment key={i}>
                                                                <span dangerouslySetInnerHTML={{ __html: line }} />
                                                                <br />
                                                            </React.Fragment>
                                                        ))
                                                    )
                                                        
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    )
                                ) : null}
                            </div>
                        ))
                    )}
                    <div ref={messagesEndRef} className='graphsItems' />
                </Col>
            </Row>

            <Container className="mt-auto askingRow fixed-bottom">
                <Form onSubmit={handleSubmitText} className="d-flex chat-input w-100">
                    <Form.Group className="mb-3 d-flex w-100">
                        <Col xs={10} className="d-flex">
                            <Form.Control
                                type="text"
                                onChange={handleChange}
                                value={formValues.message}
                                placeholder="Enter your message"
                                className="w-100 chatFormInput"
                                readOnly={loading}
                            />
                        </Col>
                        <Col xs={2} className="askBtns d-flex justify-content-around" style={{marginLeft:"10px"}}>
                            <Button type="submit" className="text-btn send-button w-50 " disabled={loading}>
                                <div className="svg-wrapper-1">
                                    <div className="svg-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" className="bi bi-fonts" viewBox="0 0 16 16">
                                            <path d="M12.258 3h-8.51l-.083 2.46h.479c.26-1.544.758-1.783 2.693-1.845l.424-.013v7.827c0 .663-.144.82-1.3.923v.52h4.082v-.52c-1.162-.103-1.306-.26-1.306-.923V3.602l.431.013c1.934.062 2.434.301 2.693 1.846h.479z"/>
                                        </svg>
                                    </div>
                                </div>
                            </Button>
                            <Button type="button" onClick={handleSubmitGraph} className="graph-btn send-button ml-2 w-50" disabled={loading}>
                                <div className="svg-wrapper-1">
                                    <div className="svg-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" className="bi bi-graph-up" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M0 0h1v15h15v1H0zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07"/>
                                        </svg>
                                    </div>
                                </div>
                            </Button>
                        </Col>
                    </Form.Group>
                </Form>
            </Container>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Save Question</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Question Content</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={savedQuestions}
                            readOnly
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSaveQuestion}>
                        Save Question
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
}

export default Chat;
